import {
  Chip,
  HStack,
  Pressable,
  Text,
} from '@ayble-health/dashboard-components';
import React from 'react';
import { Box, useToken } from '@chakra-ui/react';
import { ChevronRight, Clock } from 'lucide-react';
import CalendarSVG from '../../CustomSVGs/CalendarSVG';

type Props = {
  clientConfirmed: boolean;
  date: string;
  onPress: () => void;
  providerLabel: string;
  time: string;
};

export const MeetingBlockCard = ({
  clientConfirmed,
  date,
  onPress,
  providerLabel,
  time,
}: Props) => {
  const confirmationLabel = clientConfirmed ? 'Confirmed' : 'Unconfirmed';
  const [seafoam] = useToken('colors', ['seafoam']);

  return (
    <Pressable onClick={onPress} w={'100%'}>
      <Box w={'100%'}>
        <HStack justifyContent={'space-between'} w={'100%'}>
          <Text
            color={'secondary.500'}
            fontSize={'16px'}
            fontWeight={'normal'}
            textAlign={'left'}
          >
            {providerLabel}
          </Text>

          <Chip
            variant={clientConfirmed ? 'aqua' : 'symptom'}
            fontSize={'xs'}
            fontWeight={'semibold'}
          >
            {confirmationLabel}
          </Chip>
        </HStack>

        <HStack alignItems={'center'} justifyContent={'space-between'} mt={2}>
          <HStack alignItems={'center'} gap={4}>
            <HStack alignItems={'center'} gap={1}>
              <CalendarSVG height={12} width={12} />
              <Text color={'blueGray.600'} fontSize={'12px'}>
                {date}
              </Text>
            </HStack>

            <HStack alignItems={'center'} gap={1}>
              <Clock color={'#2D6670'} size={12} />
              <Text color={'blueGray.600'} fontSize={'12px'}>
                {time}
              </Text>
            </HStack>
          </HStack>

          <ChevronRight color={seafoam} size={16} />
        </HStack>
      </Box>
    </Pressable>
  );
};
